import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';

import { useCallback } from 'react';

import { Button } from '@chakra-ui/react';

import { accommodationSlice, useAppSelector } from '@app/state';

import { ApartmentBookButtonProps } from './apartment-book-button.props';

export const ApartmentBookButton = ({
    apartmentVariant,
    apartmentId,
    ...props
}: ApartmentBookButtonProps) => {
    const { push } = useRouter();
    const { t } = useTranslation('accommodation');
    const checkoutUrl = useAppSelector(
        accommodationSlice.selectors.selectVariantUrl(apartmentVariant, apartmentId),
    );

    const handleBtnClick = useCallback(() => {
        if (!checkoutUrl) return;

        push(checkoutUrl);
    }, [checkoutUrl]);

    return (
        <Button colorPalette={'secondary'} onClick={handleBtnClick} {...props}>
            {t('buttons.book')}
        </Button>
    );
};
